/* External Imports */

/* Internal Imports */
/* Components */

/**
 * Renders Render Simple Button Component
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Render Simple Button Component
 */

import { Box, Flex } from '@chakra-ui/react';
import SectionTitle from '@eternal/Components/Headings/SectionTitle';
import MidContainer from '@eternal/Components/Layout/MidContainer';
import React from 'react';

const ListenNow = ({ sectionContent, region, lang }) => {
  const findElement = param =>
    sectionContent.find(el => el._modelApiKey === param);
  return (
    <MidContainer w={1180}>
      <Box>
        <SectionTitle titleObj={findElement('section_title')} />
      </Box>
      <Flex flexWrap="wrap" justifyContent="space-between" w="100%">
        {sectionContent
          .filter(el => el._modelApiKey === 'media_embed')
          .map(el => (
            <>
              <Box
                as="iframe"
                rounded="12px"
                src={el.embedUrl.split('&theme=0')[0]}
                width={{
                  base: '100%',
                  md: el.source === 'applemusic' ? '44%' : '54%',
                }}
                minH={{ base: '165px', lg: '320px', xl: '360px' }}
                frameBorder="0"
                minW={280}
                allowfullscreen=""
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              ></Box>
            </>
          ))}
      </Flex>
    </MidContainer>
  );
};

export default ListenNow;
